import { render, staticRenderFns } from "./FlightDetails.vue?vue&type=template&id=5c8c338b"
import script from "./FlightDetails.vue?vue&type=script&lang=js"
export * from "./FlightDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports